import React from 'react'
import TopHeader from '../../Components/TopHeader'
import QueryDisplayTable from './QueryDisplayTable'
import Sidebar from '../../Components/Sidebar'

const Query = () => {
    return (
        <div>
            <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
                <Sidebar />
                <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                    <TopHeader pageName="Email Requests" />
                    <div id="content-container" className="flex-1 overflow-auto p-6">
                        <QueryDisplayTable />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Query
